export default {
    "商务合作": "Business Cooperation",
    "MANA商务合作": "Business Cooperation",
    "活动": "Events",
    "论坛 / 沙龙 / 讲座 / 演出 / 工作坊 / 展览 / 直播 /其他": "Forum / Salon / Lecture / Performance / Workshop / Exhibition / Live streaming / Others",
    "预约服务": "Reserve",
    "我要合作": "Cooperate",
    "广告推广": "Ads",
    "网站 / APP / 微信公众号": "Website / APP / WeChat Official Account",
    "了解详情": "More Info",
    "竞赛与征集": "Competition and Collection",
    "全案策划 / 征集及推广 / 评委及评选 / 活动及转化": "Project Planning / Open call and Promoting / Jury and Judgement / Activity and more",
    "销售合作": "Sales Cooperation",
    "课程 / 票务 / 书籍": "Course / Tickets / Books",
    "其它商务服务": "For other business, please contact",
    "服务热线": "Tel",
    "商务合作邮箱": "Email",
    "workTime": "(Working Hours: Workday 9：30 a.m. - 6：00 p.m.)",
    "广告刊例": "Ads",
    "微信公众号": "WeChat Official Account",
    "新媒体艺术站": "mediaart",
    "内容需经过审核，至少提前两周预约排期": "The content needs to be audited. Please make an appointment at least two weeks in advance.",
    "服务类型": "Service Type",
    "广告形式": "Advertisement Type",
    "发布时长": "Unit",
    "备注": "Remarks",
    "内容采编": "Content Editing",
    "头条发布": "Headline Publishing",
    "次条发布": "Sub-headline Publishing",
    "头条文末链接": "Headline Link",
    "软文": "Advertorial",
    "图文链接": "Graphic link",
    "1次": "1 piece of article",
    "1周": "1 week",
    "需提供素材": "Material Required",
    "文字介绍、相关视频、动图或图片、涉及到的艺术家或团队介绍、赠票或衍生品服务（粉丝福利）": "text introduction; related video, motion-graph or image; introduction of the concerning artist or studio; complimentary ticket; derivatives (bonus for fans) ",
    "网站和APP": "Website & APP",
    "内容和素材需经过审核；了解更多信息请联系右侧人工客服咨询。": "内容和素材需经过审核；了解更多信息请联系右侧人工客服咨询。",
    "网站+APP首页": "Website+APP Homepage",
    "Banner第二、三帧（见下图A1）": "Banner(the second、third frame) A1",
    "网站首页": "Website Homepage",
    "频道推荐第二位（见下图A2）": "Channel recommended (the second) A2",
    "活动推荐第二位（见下图A3）": "Activity recommended (the second) A3",
    "优秀创作者第二位（见下图A4）": "Artist recommended (the second) A4",
    "大于2M的图片素材（请确认已授权）、文字内容": "Image material bigger than 2M, text content",
    "位置示意": "Examples",
    "联系方式": "Contact Us",
    "项目对接": "Project Docking",
    "合作": "Cooperation",
    "产商服务": "Industrial & Commercial Services",
    "MANA产商服务": "Industrial & Commercial Services",
    "为企业和政府提供基于科技艺术产业链的咨询、资源整合以及整体解决方案服务；输出和定制具有“投入-产出”闭环逻辑和IP属性的内容型产品。": "MANA provides enterprises and government with consulting, resource integration and overall solution services based on the industry chain of technological art; Output and customize content-based products with “input-output” closed-loop logic and IP attributes.",
    "服务接洽": "Reservation",
    "四大服务": "Four Services",
    "咨询顾问": "Consulting",
    "科技艺术生产效率赋能": "· Enhancement of production efficiency relating to technology and art",
    "科技艺术场景与品牌赋能": "· Enrichment of the technology-art-related brands and scenes",
    "科技艺术产品与运营赋能": "· Improvement on technology-art-related production and operation",
    "科技艺术战略与模型": "· Strategy and model of technology art",
    "资源整合": "Resourcing",
    "内容与创作者资源整合": "· Integration of contents and art resources",
    "科技艺术产业链整合": "· Integration of the technology art industry chain",
    "科技艺术教育培训资源整合": "· Integration of education & training resources",
    "项目与资本资源整合": "· Integration of projects and capitals",
    "解决方案": "Solutions",
    "科技艺术新策略、新产品的规划与实施": "· Plan and implement of technology-art-related strategy and production",
    "咨询-方案-资源-落地-运营的全案整合服务": "· one package service of consulting - planning - resourcing - realizing - operating",
    "长期战略型科技艺术项目的落地": "· Implement of long-term strategic technology-art-related projects",
    "构建科技艺术产品体系和运营系统": "· Constructing technology art product structure and operation system",
    "产品输出": "Output",
    "服务产品": "· Service",
    "基于屏幕的商业与公共空间数字艺术周期性策展": "Periodic digital art exhibition curating based on the screens in commercial/public spaces",
    "数字艺术内容赋能展览展示": "Display and Exhibition of digital art contents",
    "科技艺术未来生活场景实验室": "Technological art lab of future life",
    "场馆产品": "· Venue",
    "沉浸式新媒体艺术主题系列乐园": "Immersive new media art theme park",
    "科技艺术主题系列美术馆、博物馆": "Technology-art-related museums",
    "城市产品": "· City",
    "科技艺术产业、文旅及商业园区（或综合体）": "Complex of technology art industry, cultural tourism and commercial parks",
    "科技艺术产业、商业及生活街区": "Technology art industry, commerce and living block",
    "城市科技艺术节庆活动系列产品": "City Technology-Art-related Festivals or Activities",
    "市场&应用": "Application Scenarios",
    "城市活动": "Urban Activities",
    "艺术节": "Art Festival",
    "竞赛": "Competition",
    "活动周": "Activity Week",
    "社区服务": "Community service",
    "乡镇活动": "Town Area Activities",
    "城市空间": "Urban Space",
    "交通枢纽": "Transportation Junction",
    "广场公园": "Squares and Parks",
    "街景河景": "Streets and Riversides",
    "商业空间": "Commercial plazas/spaces",
    "文化复兴": "Renaissance/Art Revival",
    "文保数字化": "Cultural Heritage Preservation Digitalization",
    "IP研发": "IP Research and development",
    "节庆活动": "Festival Acitivities",
    "文化场馆": "Cultural Sites",
    "文旅夜游": "Nocturnal Cultural Tourism",
    "景区赋能": "Resort Empowerment",
    "内容整合": "Content Integration",
    "内容与场景开发": "Content and Scene Development",
    "运作系统整合": "Operation System Integration",
    "样板场景打造": "Sample Scene Production",
    "园区/街区/产城": "Campus/Block/Industry Park",
    "新基建内容场景": "New Infrastructure Scene",
    "智慧城市": "Smart City",
    "城市更新": "City Renewal",
    "新型产业园区": "New Industry Park",
    "其他服务请联系": "For other service, please contact",
    "关于MANA": "About MANA",
    "MANA是全球科技艺术产业的整合服务平台。": "MANA is a platform to present contents and artists relating to global technological art industry, gathering technological art resources and offering industry chain integration service and efficiency-raising service. It researches and develops the next-generation technological art scene and service products for cultural and creative industries, commercial cultural tourism, exhibitions, festivals and urban/suburban operations.",
    "基于全球的内容与创作者分享平台，聚集科技艺术专业及产业资源，提供产业链整合及增效服务。": "",
    "为文创娱乐、商业文旅、会展节庆及城市乡村运营，研发下一代际科技艺术场景与服务产品。": "",
    "联系邮箱": "Email",
    "内容需经过审核": "The content needs to be audited.",
    "了解更多信息请联系人工客服": "Please contact if you want more information.",
    "项目对接服务": "Project Docking Sevice",
    "如果您的项目想要对接MANA平台上的入驻团队，请前往": "If your project wants to connect with the settled team on the MANA platform, please go to ",
    "板块发布需求": " section to release requirements.",
    "资源对接": "Intermediary Service",
    "推荐适配团队/作品": "Artist / Artwork recommendation and cooperation",
    "我有需求": "Require"
}



// WEBPACK FOOTER //
// ./src/languages/en/business.js